<template>
    <div class="text-center mt-4 text-white">

        <div v-if="loaded">
            <p class="uppercase text-xs">Account Listing</p>
            <h1 class="center text-4xl block">{{listing.displayName}}</h1>  
            <h3 class="text-sm">Seller: {{listing.seller}}</h3>  

                <h5 class="mt-4">1 Litecoin = {{ltcPrice}} USD (price from <a href="https://www.coingecko.com/en/coins/litecoin" class="underline">Coingecko</a>)</h5>

    <p class="text-xs text-red-500" v-if="couponText" v-text="couponText"></p>

            <table class="table-fixed m-auto">
            <thead>
                <tr>
                <th class="px-4 py-2">Field</th>
                <th class="px-4 py-2">Value</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <td class="border px-4 py-2">Region</td>
                <td class="border px-4 py-2">{{listing.region}}</td>
                </tr>
                <tr>
                <td class="border px-4 py-2">Display Name</td>
                <td class="border px-4 py-2">{{listing.displayName}}</td>
                </tr>
                <tr>
                <td class="border px-4 py-2">Rank</td>
                <td class="border px-4 py-2"><img class="float-left" style="max-width:25px" :src="getRankImage()" /> {{listing.rank}}</td>
                </tr>
                <tr>
                <td class="border px-4 py-2">CPU</td>
                <td class="border px-4 py-2">{{listing.cpu}}</td>
                </tr>
                <tr>
                <td class="border px-4 py-2">GPU</td>
                <td class="border px-4 py-2">{{listing.gpu}}</td>
                </tr>
                <tr>
                <td class="border px-4 py-2">Price in USD</td>
                <td class="border px-4 py-2">${{listing.price}} USD</td>
                </tr>
                <tr>
                <td class="border px-4 py-2">Price in Litecoin</td>
                <td class="border px-4 py-2">around {{Math.round(listing.price/ltcPrice * 10000) / 10000.0}} LTC</td>
                </tr>
                <tr v-if="multiplier != 1">
                <td class="border px-4 py-2">Price (USD) (Coupon)</td>
                <td class="border px-4 py-2">{{Math.ceil(listing.price * multiplier)}} USD</td>
                </tr>
                <tr v-if="multiplier != 1">
                <td class="border px-4 py-2">Price (LTC) (Coupon)</td>
                <td class="border px-4 py-2">around {{Math.round( Math.ceil(listing.price * multiplier)/ltcPrice * 10000) / 10000.0}} LTC</td>
                </tr>                                                             
            </tbody>
            </table>

            <p class="uppercase text-xs">Confirm all the info above is correct</p>


    <div class="w-1/3 m-auto  mb-6 md:mb-0">
      <label class="block uppercase tracking-wide text-red-500 text-xs font-bold mb-2" for="grid-city">
        Coupon Code
      </label>
      <input v-model="couponCode" class="appearance-none block w-full bg-gray-700 text-gray-200 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-gray-500" id="coupon" type="text" placeholder="Enter code (if applicable)">
    </div>

        <ul class="flex justify-center w-1/4 m-auto mt-4 md:w-5/6 lg:w-1/3">

        <button @click="applyCoupon"  class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500">Apply Coupon</button>

        </ul>

            <div class="mt-8" v-if="userData.payAddress">


                <p>Your Litecoin Payments Address is set to: <span class="underline">{{userData.payAddress}}</span></p>
                <p class="text-red-500 uppercase text-xs">We will be expecting payment from this address!</p>



                <p class="mt-2">Click the button below to request a Litecoin Address to send payment.</p>

        <ul v-if="!addressRequested" class="flex justify-center w-1/4 m-auto mt-2 md:w-5/6 lg:w-1/3">

        <button @click="requestAddress"  class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500">Request Address</button>

        </ul>


            <div v-if="toAddress" class="mt-2">

                <p>Send {{Math.round( Math.ceil(listing.price * multiplier)/ltcPrice * 10000) / 10000.0}} Litecoin to <span class="text-green-500">{{toAddress}}</span></p>

             <vue-qrcode class="m-auto mt-4" :value="toAddress" />




             </div>

                <p id="countdown"></p>

        <div v-if="toAddress">

            <p>Once <span class="text-green-500">{{toAddress}}</span> has received at least {{Math.round( Math.ceil(listing.price * multiplier)/ltcPrice * 10000) / 10000.0}} Litecoin from <span class="text-red-500">{{userData.payAddress}}</span> , this listing will be added to your "Purchased Accounts" tab on your account page.</p>
            <p class="mt-2"> This process can take up to 30 minutes. If there are any issues at all, email us at buyers@<span class="text-red-500">Valorant</span>Accounts.net</p>

        </div>

          </div>

            <div v-else>
                <p class="text-red-500">You have not set your Litecoin Payment Address yet! Set it in your account settings!</p>
            </div>

        </div>

        <div v-else>
            <p>Loading listing info..</p>
        </div>

    </div>
</template>


<script>
import firebase from 'firebase/app'
import db from '@/db'

import ltc from '@/ltc'

import axios from 'axios'

import VueQrcode from 'vue-qrcode'

let listingRef;
let userRef;

export default {
  name: 'Listing',
  components: {VueQrcode},
  data () {
    return {
        loaded: false,
        listing: {},
        userData: {},
        ltcPrice: 0,
        couponCode: '',
        multiplier: 1,
        couponText: '',
		rankIcons: {
		  gold: require('@/assets/ranks/gold.png'),
		  immortal: require('@/assets/ranks/immortal.png'),  
		  plat: require('@/assets/ranks/plat.png'), 
		  diamond: require('@/assets/ranks/diamond.png'),
		  radiant:  require('@/assets/ranks/radiant.png'),
		  silver:  require('@/assets/ranks/silver.png'),
		  bronze:  require('@/assets/ranks/bronze.png'), 
		  iron:  require('@/assets/ranks/iron.png'),  		  
        },
        
        toAddress: '',
        addressRequested: false,
    }
  },
 beforeMount(){

    listingRef = db.collection("Listings").doc(this.$route.params.id)

    userRef = db.collection("Users").doc(firebase.auth().currentUser.uid)
    //Get listing data
    listingRef.get()
    .then(doc => {
        this.listing = doc.data()
        return userRef.get()
    })
    .then(doc => {
        this.userData = doc.data()
        //Now get Litecoin conversion rate
        return axios.get("https://api.coingecko.com/api/v3/simple/price?ids=litecoin&vs_currencies=usd")
    })
    .then(res => {
        this.ltcPrice = res.data.litecoin.usd

        this.checkCoupons();


        this.loaded = true;
    })

 },
 mounted() {

 },
 methods: {
	 getRankImage() {
			

			if (this.listing.rank == 'RADIANT') {
				return this.rankIcons.radiant
			} else if (this.listing.rank.includes('Immortal')) {
				return this.rankIcons.immortal
			} else if (this.listing.rank.includes('Diamond')) {
				return this.rankIcons.diamond
			} else if (this.listing.rank.includes('Plat')) {
				return this.rankIcons.plat
			} else if (this.listing.rank.includes('Gold')) {
				return this.rankIcons.gold
			} else if (this.listing.rank.includes('Silver')) {
				return this.rankIcons.silver
			} else if (this.listing.rank.includes('Bronze')) {
				return this.rankIcons.bronze
			} else if (this.listing.rank.includes('Iron')) {
				return this.rankIcons.iron
			}
			

        },
    applyCoupon() {
        this.$router.replace({path: this.$route.path, query: {coupon: this.couponCode}})
        this.couponCode = ''
        this.checkCoupons();
    },
    requestAddress() {

        //First update the LTC price so we dont get finessed
        axios.get("https://api.coingecko.com/api/v3/simple/price?ids=litecoin&vs_currencies=usd")
        .then(res => {
            this.ltcPrice = res.data.litecoin.usd

            //Get a random address from the list
            this.toAddress = ltc[Math.round(Math.random()*200)]["1"];
            this.addressRequested = true

            const thirtyMinutes = 60 * 30;
            const display = document.querySelector('#countdown');
            this.startTimer(thirtyMinutes, display);

            //Save the data of the request to the database
            
            let paymentRequestData = {
                amountLTC: Math.round(Math.ceil(this.listing.price * this.multiplier)/this.ltcPrice * 10000) / 10000.0,
                amountUSD: Math.ceil(this.listing.price * this.multiplier),
                couponCode: 'none',
                fromAddress: this.userData.payAddress,
                toAddress: this.toAddress,
                type: 'LISTING',
                when: new Date(),
            }

            if (this.$route.query.coupon) {
              paymentRequestData.couponCode = this.$route.query.coupon
            }

            return db.collection("PaymentRequests").add(paymentRequestData)
        })
        .then(docRef => {

        })



    },
    checkCoupons() {

        //Setup coupon stuff too right now
        if (this.$route.query.coupon) {
            const coupon = this.$route.query.coupon.toUpperCase()
            if (coupon == 'NARCOTICS') {
                this.couponText = 'VA-Narcotics 20% Referral Coupon Applied!'
                this.multiplier = 0.8
            } else if (coupon == 'THORN') {
                this.couponText = 'VA-Thorn 20% Referral Coupon Applied!'
                this.multiplier = 0.8
            } else {
                this.couponText = "Coupon '"+coupon+"' does not exist!"
                this.multiplier = 1
            }
        }

    },
    
    startTimer(duration, display) {
        var start = Date.now(),
            diff,
            minutes,
            seconds;
        function timer() {
            // get the number of seconds that have elapsed since 
            // startTimer() was called
            diff = duration - (((Date.now() - start) / 1000) | 0);

            // does the same job as parseInt truncates the float
            minutes = (diff / 60) | 0;
            seconds = (diff % 60) | 0;

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            display.textContent = minutes + ":" + seconds; 

            if (diff <= 0) {
                // add one second so that the count down starts at the full duration
                // example 05:00 not 04:59
                start = Date.now() + 1000;
            }
        };
        // we don't want to wait a full second before the timer starts
        timer();
        setInterval(timer, 1000);
    }    

	}

}
</script>


// WEBPACK FOOTER //
// src/components/Listing.vue